<template>
  <el-dialog class="dialog-edit-mock-users" title="生成模拟参与用户" :visible.sync="visible" width="400px">
    <ConfigForms ref="form" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';

const formItems = [
  { type: 'number', label: '新增人数', key: 'count', required: true },
]

export default {
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formData: { count: null },
      formItems
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = { count: null, id: row.id }
      this.visible = true
    },
    async sure() {
      try {
        const data = await this.$refs.form.validate();
        this.$emit('sure', { isEdit: false, data })
      } catch (error) {

      }
    }
  }
}
</script>

<style lang="scss" scoped></style>